import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Label, Button, Divider } from "semantic-ui-react";

import VPNDetailsForm from "./VPNDetailsForm.jsx";

import { AT_TYPES } from "../../constants/entity.js";

import {
  selectImagesList,
  selectSizesList,
  selectVolumes
} from "../../state/reducers/projectWizard/projectWizardSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class VPNBlock extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    copyKey: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,

    apiErrors: PropTypes.object,
    configCopyKey: PropTypes.string,
    configOptions: PropTypes.object,

    resourceType: PropTypes.string.isRequired, // required for selectors to function
    formikProps: PropTypes.object.isRequired, // required for selectors to function

    imagesList: PropTypes.array.isRequired,
    sizesList: PropTypes.array.isRequired,
    volumes: PropTypes.array,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    id: "resource[0]",
    copyKey: "project_wizard.vpn_panel",
    configOptions: {}
  };

  // -- DATA MANAGEMENT -- //

  static newInstance() {
    return {
      "@type": AT_TYPES.VPN_GATEWAY,
      name: "",
      description: "",
      image: null,
      size: null,
      sitePublicIP: "",
      siteSubnet: ""
    };
  }

  // -- RENDER -- //

  renderBody = () => {
    const {
      id,
      configOptions: { singleMode },
      onRemove
    } = this.props;

    return (
      <Fragment>
        {singleMode !== true && (
          <Label attached="top">
            <Button
              onClick={() => onRemove(id)}
              icon="minus circle"
              size="mini"
              floated="right"
              type="button"
            />
          </Label>
        )}
        <Divider hidden />
        <VPNDetailsForm {...this.props} />
      </Fragment>
    );
  };

  render() {
    const {
      id,
      configOptions: { singleMode }
    } = this.props;

    if (singleMode !== true) {
      return (
        <Segment key={id} className="clear-both">
          {this.renderBody()}
        </Segment>
      );
    }

    return this.renderBody();
  }
}

const mapStateToProps = (state, props) => ({
  imagesList: selectImagesList(state, props),
  sizesList: selectSizesList(state, props),
  volumes: selectVolumes(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(VPNBlock);
